import React, { useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "../../assets/styles/components/model.scss";
import "../../assets/styles/ant/modal.scss";
import { Modal, Button, Space } from "antd";
import { Icon } from "@iconify/react";
import {
  mdiClose,
  mdiAlertOutline,
  mdiVanish,
  mdiCheckCircleOutline,
} from "@mdi/js";
import { Spin } from "antd";
interface Props {
  show?: boolean;
  title?: string;
  subTitle?: string;
  onClick?: () => void;
  onCancel?: () => void;
  path?: string;
  status?: boolean;
}

const ModalMessage: React.FC<Props> = ({
  show,
  onClick,
  onCancel,
  title,
  subTitle,
  path,
  status,
}) => {
  const navigate = useHistory();

  const navigateTo = async () => {
    navigate.push(`${path}`);
  };

  return (
    <div className="modal-opd">
      <div>
        <Modal
          visible={show}
          footer={null}
          closable={false}
          centered
          className="modal-custom"
        >
          <div className="icon-modal">
            <Icon
              icon={status ? "bi:check-circle" : "icons8:cancel"}
              color={status ? "#86CFC6" : "#E76464"}
              width="16%"
              height="16%"
              style={{ margin: "15px 0px 28px" }}
            />
          </div>
          <div className="text-modal">
            <h5>{title}</h5>
            <h5>{subTitle}</h5>
          </div>
          <div className="btn-confirm">
            <Button onClick={path !== "#" ? navigateTo : onCancel}>
              SUBMIT
            </Button>
          </div>
        </Modal>
      </div>
    </div>
  );
};
export default ModalMessage;
